<template>
  <section class="section">
    <div class="container">

      <div class="is-size-2">
        View A Lil NANO on these Block Explorers
      </div>

      <br/>
      <div class="columns is-multiline is-vcentered is-centered">
        <div class="column is-one-third">
          <a href="https://nanocrawler.prizzventuresllc.com/#/explorer/account/nano_1r98z5i14ztss597ajy3y9no5kpm1bm3uj1gam4gstjhhy3othmus1mamxyz/history" target="_blank">
            <img src="../assets/nano-crawler-prizz-logo.png" class="has-box-shadow little-scale-up-hover">
          </a>
        </div>
        <div class="column is-one-third">
          <a href="https://nanocrawler.cc/explorer/account/nano_1r98z5i14ztss597ajy3y9no5kpm1bm3uj1gam4gstjhhy3othmus1mamxyz/history" target="_blank">
            <img src="../assets/nano-crawler-logo.png" class="has-box-shadow little-scale-up-hover">
          </a>
        </div>
        <div class="column is-one-third">
          <a href="https://mynano.ninja/account/xrb_1r98z5i14ztss597ajy3y9no5kpm1bm3uj1gam4gstjhhy3othmus1mamxyz" target="_blank">
            <img src="../assets/my-nano-ninja-logo.png" class="has-box-shadow little-scale-up-hover">
          </a>
        </div>
        <div class="column is-one-third">
          <a href="https://www.nanode.co/account/nano_1r98z5i14ztss597ajy3y9no5kpm1bm3uj1gam4gstjhhy3othmus1mamxyz" target="_blank">
            <img src="../assets/nanode-logo.png" class="has-box-shadow little-scale-up-hover">
          </a>
        </div>
        <div class="column is-one-third">
          <a href="https://repnode.org/account/nano_1r98z5i14ztss597ajy3y9no5kpm1bm3uj1gam4gstjhhy3othmus1mamxyz" target="_blank">
            <img src="../assets/repnode-logo.png" class="has-box-shadow little-scale-up-hover">
          </a>
        </div>
        <div class="column is-one-third">
          <a href="https://nanocharts.info/address/nano_1r98z5i14ztss597ajy3y9no5kpm1bm3uj1gam4gstjhhy3othmus1mamxyz" target="_blank">
            <img src="../assets/nano-charts-logo.png" class="has-box-shadow little-scale-up-hover">
          </a>
        </div>
      </div>

<!--      https://nanocean.org/account/nano_1r98z5i14ztss597ajy3y9no5kpm1bm3uj1gam4gstjhhy3othmus1mamxyz-->

      <div class="is-size-2">
        More stats coming...
      </div>

    </div>
  </section>
</template>

<script>
  export default {
    name: "Statistics"
  }
</script>

<style scoped>

  .has-box-shadow {
    box-shadow: 0px 6px 50px #333;
  }

  img {
    border-radius: 8px;
  }

</style>
